/* eslint-disable camelcase */
import React, { useState, useRef, useEffect, useMemo, forwardRef, useImperativeHandle } from "react";
import "./ToursForm.css";
import { Accordion, Col, Row, Form } from "react-bootstrap";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import { SingleCalendar } from "../../../../components";
import SignatureCanvas from "react-signature-canvas";
import { ReactComponent as UploadIcon } from "../../../../assets/images/icons/solar_upload-line-duotone.svg";
import TravelerSelector from "../../../../components/TravelerSelector/TravelerSelector";
import { useTranslation } from '../../../../contexts/TranslationContext';
import axios from "axios";
import debounce from "lodash.debounce";
import Cookies from "js-cookie";
import { axiosGet } from "../../../../utils/apis/api";


const ToursForm = forwardRef(({ 
  onChange = () => {}, 
  showErrors = false, 
  initialData = null ,
  selectedDates,
  url
}, ref) => {
  const [previewImage, setPreviewImage] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const { t } = useTranslation();
  const Lang = Cookies.get("preferred_language") || "en";
  const [activeAccordionKeys, setActiveAccordionKeys] = useState(['0']);
  const sigPadRef = useRef();
  const inputRefs = useRef({});
  const [infants, setInfants] = useState(0);


  // Map fields to accordion sections
  const fieldToAccordionMap = {
    // Personal Information
    fullName: '0',
    nationality: '0',
    phone: '0',
    
    // Tour Details
    destination: '1',
    tourType: '1',
    tourDuration: '1',
    preferredTourDate: '1',
    childrenAges: '1',
    
    // Payment & Billing
    paymentMethod: '2',
    billingAddress: '2',
    invoiceRequired: '2',
    
    // Declaration & Signature
    agreeTerms: '5',
    signature: '5',
    
    // Files
    file_passport_copy: '4'
  };

  /* ──────────────────────────────── State ─────────────────────────────── */
  const initialState = {
    /* Section 1: Personal Information */
    fullName: "",
    nationality: "",
    phone: "",
    
    /* Section 2: Tour Details */
    destination: "",
    destinationName: "",
    tourPackageName: "",
    tourType: null,
    tourDuration: null,
    preferredTourDate: null,
    adults: 1,
    children: 0,
    childrenAges: [],
    specialRequests: "",
    
    /* Section 3: Payment & Billing */
    paymentMethod: null,
    billingAddress: "",
    invoiceRequired: null,
    
    /* Section 4: Travel & Contact */
    flightDetails: "",
    hotelDetails: "",
    destinationContact: "",
    
    /* Section 5: Documents */
    files: {},
    
    /* Section 6: Declaration */
    agreeTerms: false,
    signature: ""
  };

  const [form, setForm] = useState(initialState);
  const [errors, setErrors] = useState({});
      const [natQuery, setNatQuery] = useState("");
    const [natOptions, setNatOptions] = useState([]);
    const [natLoading, setNatLoading] = useState(false);
    // const fetchNationalities = useMemo(
    //   () =>
    //     debounce(async (q = "") => {
    //       try {
    //         setNatLoading(true);
    //         const params = q ? { search: q, limit: 20 } : { limit: 20 };
    //         const { data } = await axios.get(
    //           "https://viaggioerp.inter-netsys.com/api/method/alltimes.www.api.countries",
    //           { params }
    //         );
    //         setNatOptions(data.result.countries || []);
    //       } catch (e) {
    //         console.error(e);
    //       } finally {
    //         setNatLoading(false);
    //       }
    //     }, 300),
    //   []
    // );


  const fetchNationalities = useMemo(
    () =>
      debounce(async (q = "") => {
        try {
          setNatLoading(true);
          const params = q ? { search: q, limit: 20 } : { limit: 20 };
          const data = await axiosGet(
            "https://viaggioerp.inter-netsys.com/api/method/alltimes.www.api.countries",
            params
          );
          setNatOptions(data?.result?.countries || []);
        } catch (e) {
          console.error(e);
        } finally {
          setNatLoading(false);
        }
      }, 300),
    []
  );

    useEffect(() => {
      fetchNationalities(natQuery);
    }, [natQuery, fetchNationalities]);

    useEffect(() => () => fetchNationalities.cancel(), [fetchNationalities]);
  
  /* ──────────────────────────────── Destination Lookup ─────────────────────────────── */
  const [destQuery, setDestQuery] = useState("");
  const [destOptions, setDestOptions] = useState([]);
  const [destLoading, setDestLoading] = useState(false);

  // const fetchDestinations = useMemo(
  //   () => debounce(async (q = "") => {
  //     try {
  //       setDestLoading(true);
  //       const base = { location_type: "City", limit: 20 };
  //       const params = q.length >= 2 ? { ...base, search: q } : base;
        
  //       const { data } = await axios.get(
  //         "https://viaggioerp.inter-netsys.com/api/method/alltimes.www.api.locations",
  //         { params }
  //       );
        
  //       setDestOptions(data.result.locations || []);
  //     } catch (e) {
  //       console.error("Error fetching destinations:", e);
  //     } finally {
  //       setDestLoading(false);
  //     }
  //   }, 300),
  //   []
  // );

  const fetchDestinations = useMemo(
    () =>
      debounce(async (q = "") => {
        try {
          setDestLoading(true);
          const baseParams = { location_type: "City", limit: 20 };
          const params =
            q.length >= 2 ? { ...baseParams, search: q } : baseParams;
          const data = await axiosGet(
            "https://viaggioerp.inter-netsys.com/api/method/alltimes.www.api.locations",
            params
          );
          setDestOptions(data?.result?.locations || []);
        } catch (e) {
          console.error(e);
        } finally {
          setDestLoading(false);
        }
      }, 300),
    []
  );



  useEffect(() => {
    if (destQuery.length >= 2) {
      fetchDestinations(destQuery);
    }
  }, [destQuery,fetchDestinations]);

    useEffect(() => {
    return () => fetchDestinations.cancel();
  }, [fetchDestinations]);

  /* ──────────────────────────────── Initial Data ─────────────────────────────── */
  useEffect(() => {
    if (initialData) {
      setForm({
        ...initialData,
        preferredTourDate: initialData.preferredTourDate ? new Date(initialData.preferredTourDate) : null
      });
    }
  }, [initialData]);

  // Restore signature
  useEffect(() => {
    if (initialData?.signature && sigPadRef.current) {
      sigPadRef.current.fromDataURL(initialData.signature);
    }
  }, [initialData]);

  /* ──────────────────────────────── Validation ─────────────────────────────── */
  const requiredFields = {
    fullName: t("FullNameIsRequired"),
    nationality: t("NationalityIsRequired"),
    phone: t("PhoneNumberIsRequired"),
    destination: t("DestinationCountryRequired"),
    tourType: t("TourTypeIsRequired"),
    tourDuration: t("TourDurationIsRequired"),
    preferredTourDate: t("PreferredTourDateIsRequired"),
    paymentMethod: t("PaymentMethodIsRequired"),
    billingAddress: t("BillingAddressIsRequired"),
    invoiceRequired: t("PleaseSpecifyIfInvoiceIsRequired"),
    agreeTerms: t("YouMustAgreeToTheTerms"),
    signature: t("SignatureIsRequired"),
  };

  const requiredFiles = {
    passport_copy: t("PassportCopyIsRequired")
  };

  const validateForm = (data = form) => {
    const newErrors = {};
    
    // Validate required fields
    Object.entries(requiredFields).forEach(([field, message]) => {
      if (!data[field] || 
          (typeof data[field] === "string" && !data[field].trim()) ||
          (Array.isArray(data[field]) && data[field].length === 0)) {
        newErrors[field] = message;
      }
    });
    
    // Validate required files
    Object.entries(requiredFiles).forEach(([fileKey, message]) => {
      if (!data.files || !data.files[fileKey]) {
        newErrors[`file_${fileKey}`] = message;
      }
    });

    if (form.phone) {
        const phoneRegex = /^\+?[0-9]{6,15}$/;
        if (!phoneRegex.test(form.phone))
          newErrors.phone = t("InvalidPhoneNumberFormat");
    }
    
    // Validate children ages
    if (data.children > 0) {
      if (data.childrenAges.length !== data.children) {
        newErrors.childrenAges = "Please specify ages for all children";
      } else if (data.childrenAges.some(age => !age || isNaN(age) || data.childrenAges.some(age => age <= 0))) {
        newErrors.childrenAges = "Please enter valid ages for children";
      }
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // Validate form and notify parent on changes
  useEffect(() => {
    const isValid = validateForm();
    onChange(form, isValid);
  }, [form]);

  /* ──────────────────────────────── Handlers ─────────────────────────────── */
  const handleInputChange = (field, value) => {
    setForm(prev => ({ ...prev, [field]: value }));
  };

  const handleFileChange = (key, file) => {
    if (!file) return;
    setForm(prev => ({ 
      ...prev, 
      files: { ...prev.files, [key]: file } 
    }));
    if (inputRefs.current[key]) inputRefs.current[key].value = null;
  };

  const handleFileRemove = (key) => {
    setForm(prev => {
      const files = { ...prev.files };
      delete files[key];
      return { ...prev, files };
    });
    if (inputRefs.current[key]) inputRefs.current[key].value = null;
  };

  const handleSignatureEnd = () => {
    const signature = sigPadRef.current.toDataURL();
    handleInputChange("signature", signature);
  };

  const clearSignature = () => {
    sigPadRef.current?.clear();
    handleInputChange("signature", "");
  };

  /* ──────────────────────────────── Error Handling ─────────────────────────────── */
  const scrollToFirstError = () => {
    const firstErrorKey = Object.keys(errors)[0];
    if (firstErrorKey) {
      const accordionKey = fieldToAccordionMap[firstErrorKey];
      if (accordionKey && !activeAccordionKeys.includes(accordionKey)) {
        setActiveAccordionKeys(prev => [...prev, accordionKey]);
      }

      setTimeout(() => {
        const element = document.getElementById(`field-${firstErrorKey}`);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }, 300);
    }
  };

  // Auto-expand accordions when errors appear
  useEffect(() => {
    if (showErrors && Object.keys(errors).length > 0) {
      const errorAccordionKeys = Object.keys(errors)
        .map(field => fieldToAccordionMap[field])
        .filter(key => key !== undefined);
      
      setActiveAccordionKeys(prev => [
        ...prev,
        ...errorAccordionKeys.filter(key => !prev.includes(key))
      ]);
    }
  }, [showErrors, errors]);

  useImperativeHandle(ref, () => ({
    scrollToFirstError,
    validate: () => validateForm(form)
  }));

  /* ──────────────────────────────── Helpers ─────────────────────────────── */
  const err = (field) => showErrors && errors[field];
  const truncateFilename = (name, maxLength = 30) => {
    if (!name || name.length <= maxLength) return name;
    const extIndex = name.lastIndexOf(".");
    const ext = extIndex !== -1 ? name.slice(extIndex) : "";
    const base = name.slice(0, maxLength - ext.length - 3);
    return `${base}...${ext}`;
  };

  /* ──────────────────────────────── Options ─────────────────────────────── */
  const tourTypeOptions = [
    { name: "Private", label: t("Private") },
    { name: "Group", label: t("Group") },
    { name: "Customized", label: t("Customized") },
  ];

  const tourDurationOptions = [
    { name: "Half-Day", label: t("HalfDay") },
    { name: "Full-Day", label: t("FullDay") },
    { name: "Multi-Day", label: t("MultiDay") },
  ];

  const paymentMethodOptions = [
    { name: "Credit Card", label: t("CreditCard") },
    { name: "PayPal", label: t("PayPal") },
    { name: "Bank Transfer", label: t("BankTransfer") },
    { name: "Other", label: t("Other") },
  ];

  const renderAutocomplete = ({
    options,
    value,
    placeholder = t("Select"),
    fieldName,
  }) => (
    <Autocomplete
      fullWidth
      options={options}
      getOptionLabel={(o) => o.label}
      value={value ? options.find((opt) => opt.name === value) : null}
      onChange={(_, newVal) =>
        handleInputChange(fieldName, newVal?.name || null)
      }
      isOptionEqualToValue={(opt, val) => opt.name === val?.name}
      sx={{
        ".MuiAutocomplete-inputRoot": {
          fontSize: "12px",
          flexDirection: Lang === "ar" ? "row-reverse" : "row",
        },
        ".MuiAutocomplete-endAdornment": {
          left: Lang === "ar" ? "9 !important" : "unset !important",
          right: Lang === "ar" ? "unset !important" : "9 !important",
        },
        ".MuiInputBase-input": {
          textAlign: Lang === "ar" ? "right" : "left",
        },
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          size="small"
          placeholder={placeholder}
          InputProps={{
            ...params.InputProps,
            style: {
              direction: Lang === "ar" ? "rtl" : "ltr",
            },
            sx: {
              backgroundColor: "#FFF",
              borderRadius: "6px",
              padding: "9px 15px !important",
              fontFamily: '"Dmsans400"',
              fontSize: "14px !important",
              fontWeight: 400,
              letterSpacing: "0.25px",
            },
          }}
        />
      )}
    />
  );

  /* ──────────────────────────────── JSX ─────────────────────────────── */
  return (
    <Accordion
      activeKey={activeAccordionKeys}
      onSelect={(keys) => setActiveAccordionKeys(keys)}
      className="hotel-form-accordion add-service-form-accordion services-tour-form-accordion-container"
      alwaysOpen
    >
      {/* 1. Personal Information */}
      <Accordion.Item eventKey="0" className="hotel-form-accordion-item">
        <Accordion.Header className="hotel-form-accordion-header">
          1. {t("PersonalInformation")}
        </Accordion.Header>
        <Accordion.Body className="hotel-form-accordion-body">
          <Row>
            <Col xl={4} md={6}>
              <div className="hotel-form-input-container" id="field-fullName">
                <label className="hotel-form-input-label">
                  {t("FullName")} <span>*</span>
                </label>
                <input
                  type="text"
                  className="hotel-form-input"
                  value={form.fullName}
                  onChange={(e) =>
                    handleInputChange("fullName", e.target.value)
                  }
                  placeholder={t("FullName")}
                />
                {err("fullName") && (
                  <div className="field-error">{errors.fullName}</div>
                )}
              </div>
            </Col>

            <Col xl={4} md={6}>
              <div
                className="hotel-form-input-container"
                id="field-nationality"
              >
                <label className="hotel-form-input-label">
                  {t("Nationality")} <span>*</span>
                </label>
                  <Autocomplete
                    options={natOptions}
                    loading={natLoading}
                    getOptionLabel={(o) => o.name || ""}
                    dir={Lang === "ar" ? "rtl" : "ltr"}
                    value={
                      natOptions.find((o) => o.name === form.nationality) ||
                      null
                    }
                    onInputChange={(_, v) => setNatQuery(v)}
                    onChange={(_, v) =>
                      setForm((p) => ({ ...p, nationality: v?.name || "" }))
                    }
                    sx={{
                      ".MuiAutocomplete-inputRoot": {
                        fontSize: "12px",
                        flexDirection: Lang === "ar" ? "row-reverse" : "row",
                      },
                      ".MuiAutocomplete-endAdornment": {
                        left:
                          Lang === "ar" ? "9 !important" : "unset !important",
                        right:
                          Lang === "ar" ? "unset !important" : "9 !important",
                      },
                      ".MuiInputBase-input": {
                        textAlign: Lang === "ar" ? "right" : "left",
                      },
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        size="small"
                        placeholder={t("SelectNationality")}
                        InputProps={{
                          ...params.InputProps,
                          style: {
                            direction: Lang === "ar" ? "rtl" : "ltr",
                          },
                          sx: {
                            backgroundColor: "#FFF",
                            borderRadius: "6px",
                            padding: "9px 15px !important",
                            fontFamily: '"Dmsans400"',
                            fontSize: "14px !important",
                            fontWeight: 400,
                            letterSpacing: "0.25px",
                          },
                        }}
                      />
                    )}
                  />
                {err("nationality") && (
                  <div className="field-error">{errors.nationality}</div>
                )}
              </div>
            </Col>

            <Col xl={4} md={6}>
              <div className="hotel-form-input-container" id="field-phone">
                <label className="hotel-form-input-label">
                  {t("ContactNumber")} <span>*</span>
                </label>
                <input
                  type="tel"
                  className="hotel-form-input"
                  value={form.phone}
                  onChange={(e) => handleInputChange("phone", e.target.value)}
                  placeholder={t("PhoneNumber")}
                />
                {err("phone") && (
                  <div className="field-error">{errors.phone}</div>
                )}
              </div>
            </Col>
          </Row>
        </Accordion.Body>
      </Accordion.Item>

      {/* 2. Tour Details */}
      <Accordion.Item eventKey="1" className="hotel-form-accordion-item">
        <Accordion.Header className="hotel-form-accordion-header">
          2. {t("TourDetails")}
        </Accordion.Header>
        <Accordion.Body className="hotel-form-accordion-body">
          <Row>
            <Col xl={4} md={6}>
              <div
                className="hotel-form-input-container"
                id="field-destination"
              >
                <label className="hotel-form-input-label">
                  {t("Destination")} <span>*</span>
                </label>
                <Autocomplete
                  options={destOptions}
                  loading={destLoading}
                  getOptionLabel={(o) => {
                    const city = (o.location_name || "")
                      .replace(/\s+/g, " ")
                      .trim();
                    const parent = (o.parent_location_name || "")
                      .replace(/\s+/g, " ")
                      .trim();
                    return parent ? `${city} (${parent})` : city;
                  }}
                  value={
                    form.destination
                      ? destOptions.find(
                          (o) => o.name === form.destination
                        ) || {
                          name: form.destination,
                          location_name: form.destinationName,
                        }
                      : null
                  }
                  // value={
                  //   form.destination
                  //     ? {
                  //         name: form.destination,
                  //         location_name: form.destinationName || "",
                  //       }
                  //     : null
                  // }
                  onOpen={() => !destOptions.length && fetchDestinations()}
                  onInputChange={(_, v, r) => r === "input" && setDestQuery(v)}
                  onChange={(_, v) => setForm(p => ({
                    ...p,
                    destination: v?.name || null,
                    destinationName: v?.location_name || "",
                  }))}
                  sx={{
                      ".MuiAutocomplete-inputRoot": {
                        fontSize: "12px",
                        flexDirection: Lang === "ar" ? "row-reverse" : "row",
                      },
                      ".MuiAutocomplete-endAdornment": {
                        left:
                          Lang === "ar" ? "9 !important" : "unset !important",
                        right:
                          Lang === "ar" ? "unset !important" : "9 !important",
                      },
                      ".MuiInputBase-input": {
                        textAlign: Lang === "ar" ? "right" : "left",
                      },
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      size="small"
                      placeholder={t("SelectDestination")}
                      InputProps={{
                          ...params.InputProps,
                          style: {
                            direction: Lang === "ar" ? "rtl" : "ltr",
                          },
                          sx: {
                            backgroundColor: "#FFF",
                            borderRadius: "6px",
                            padding: "9px 15px !important",
                            fontFamily: '"Dmsans400"',
                            fontSize: "14px !important",
                            fontWeight: 400,
                            letterSpacing: "0.25px",
                          },
                      }}
                    />
                  )}
                />
                {err("destination") && (
                  <div className="field-error">{errors.destination}</div>
                )}
              </div>
            </Col>

            <Col xl={4} md={6}>
              <div className="hotel-form-input-container" id="field-tourType">
                <label className="hotel-form-input-label">
                  {t("TourType")} <span>*</span>
                </label>
                {renderAutocomplete({
                  options: tourTypeOptions,
                  value: form.tourType,
                  placeholder: t("SelectTourType"),
                  fieldName: "tourType",
                })}
                {err("tourType") && (
                  <div className="field-error">{errors.tourType}</div>
                )}
              </div>
            </Col>

            <Col xl={4} md={6}>
              <div
                className="hotel-form-input-container"
                id="field-tourDuration"
              >
                <label className="hotel-form-input-label">
                  {t("TourDuration")} <span>*</span>
                </label>
                {renderAutocomplete({
                  options: tourDurationOptions,
                  value: form.tourDuration,
                  placeholder: t("SelectDuration"),
                  fieldName: "tourDuration",
                })}
                {err("tourDuration") && (
                  <div className="field-error">{errors.tourDuration}</div>
                )}
              </div>
            </Col>

            <Col xl={4} md={6}>
              <div
                className="hotel-form-input-container"
                id="field-preferredTourDate"
              >
                <label className="hotel-form-input-label">
                  {t("PreferredDate")} <span>*</span>
                </label>
                <SingleCalendar
                  value={form.preferredTourDate}
                  onChange={(e) =>
                    handleInputChange("preferredTourDate", e.value)
                  }
                  placeholder={t("SelectDate")}
                  min={new Date(selectedDates.startDate)} 
                  max={new Date(selectedDates.endDate)}
                  viewDate={new Date(selectedDates.endDate)}
                  showTime={false}
                />
                {err("preferredTourDate") && (
                  <div className="field-error">{errors.preferredTourDate}</div>
                )}
              </div>
            </Col>

            <Col xl={4} md={6}>
              <div
                className="hotel-form-input-container"
                id="field-childrenAges"
              >
                <label className="hotel-form-input-label">
                  {t("Travelers")} <span>*</span>
                </label>
                <TravelerSelector
                  adults={form.adults}
                  children={form.children}
                  childrenAges={form.childrenAges}
                  infants={infants}
                  onAdultsChange={(val) =>
                    handleInputChange("adults", parseInt(val) || 1)
                  }
                  onChildrenChange={(val) => {
                    const count = parseInt(val) || 0;
                    handleInputChange("children", count);

                    // Adjust childrenAges array
                    if (count > form.childrenAges.length) {
                      // Add empty ages for new children
                      const newAges = [...form.childrenAges];
                      while (newAges.length < count) newAges.push("");
                      handleInputChange("childrenAges", newAges);
                    } else if (count < form.childrenAges.length) {
                      // Remove extra ages
                      const newAges = form.childrenAges.slice(0, count);
                      handleInputChange("childrenAges", newAges);
                    }
                  }}
                  onChildrenAgesChange={(val) =>
                    handleInputChange("childrenAges", val)
                  }
                  onInfantsChange={setInfants}
                />
                {err("childrenAges") && (
                  <div className="field-error">{errors.childrenAges}</div>
                )}
              </div>
            </Col>
          </Row>
        </Accordion.Body>
      </Accordion.Item>

      {/* 3. Payment & Billing Information */}
      <Accordion.Item eventKey="2" className="hotel-form-accordion-item">
        <Accordion.Header className="hotel-form-accordion-header">
          3. {t("PaymentBilling")}
        </Accordion.Header>
        <Accordion.Body className="hotel-form-accordion-body">
          <Row>
            <Col xl={4} md={6}>
              <div
                className="hotel-form-input-container"
                id="field-paymentMethod"
              >
                <label className="hotel-form-input-label">
                  {t("PaymentMethod")} <span>*</span>
                </label>
                {renderAutocomplete({
                  options: paymentMethodOptions,
                  value: form.paymentMethod,
                  placeholder: t("SelectPaymentMethod"),
                  fieldName: "paymentMethod",
                })}
                {err("paymentMethod") && (
                  <div className="field-error">{errors.paymentMethod}</div>
                )}
              </div>
            </Col>

            <Col xl={8} md={6}>
              <div
                className="hotel-form-input-container"
                id="field-billingAddress"
              >
                <label className="hotel-form-input-label">
                  {t("BillingAddress")} <span>*</span>
                </label>
                <input
                  type="text"
                  className="hotel-form-input"
                  value={form.billingAddress}
                  onChange={(e) =>
                    handleInputChange("billingAddress", e.target.value)
                  }
                  placeholder={t("EnterBillingAddress")}
                />
                {err("billingAddress") && (
                  <div className="field-error">{errors.billingAddress}</div>
                )}
              </div>
            </Col>

            <Col xl={12}>
              <div
                className="add-service-form-checkbox-container"
                id="field-invoiceRequired"
              >
                <div className="add-service-form-checkbox-title">
                  {t("InvoiceRequired?")} <span style={{ color: "red" }}> *</span>
                </div>
                <Form className="add-service-form-checkboxes">
                  {["yes", "no"].map((opt) => (
                    <Form.Check
                      key={opt}
                      inline
                      type="radio"
                      label={opt === "yes" ? t("Yes") : t("No")}
                      name="invoiceRequired"
                      value={opt}
                      checked={form.invoiceRequired === opt}
                      onChange={() => handleInputChange("invoiceRequired", opt)}
                      className="add-service-form-checkbox"
                    />
                  ))}
                </Form>
                {err("invoiceRequired") && (
                  <div className="field-error">{errors.invoiceRequired}</div>
                )}
              </div>
            </Col>
          </Row>
        </Accordion.Body>
      </Accordion.Item>

      {/* 4. Travel & Contact Details (Optional) */}
      <Accordion.Item eventKey="3" className="hotel-form-accordion-item">
        <Accordion.Header className="hotel-form-accordion-header">
          4. {t("TravelContactDetails")}
        </Accordion.Header>
        <Accordion.Body className="hotel-form-accordion-body">
          <Row>
            <Col xl={4} md={6}>
              <div className="hotel-form-input-container">
                <label className="hotel-form-input-label">
                  {t("FlightDetails")}
                </label>
                <input
                  type="text"
                  className="hotel-form-input"
                  value={form.flightDetails}
                  onChange={(e) =>
                    handleInputChange("flightDetails", e.target.value)
                  }
                  placeholder={t("FlightDetails")}
                />
              </div>
            </Col>
            {/* Other optional fields... */}
          </Row>
        </Accordion.Body>
      </Accordion.Item>

      {/* 5. Supporting Documents */}
      <Accordion.Item eventKey="4" className="hotel-form-accordion-item">
        <Accordion.Header className="hotel-form-accordion-header">
          5. {t("SupportingDocuments")}
        </Accordion.Header>
        <Accordion.Body className="hotel-form-accordion-body">
          <Row>
            <Col xl={6} md={6}>
              <div
                className="hotel-form-input-container"
                id="field-file_passport_copy"
              >
                <label className="hotel-form-input-label">
                  {t("PassportCopy")} <span>*</span>
                </label>
                <div className="custom-upload-wrapper">
                  <input
                    id="file-passport_copy"
                    type="file"
                    accept=".pdf, .png, .jpeg, .jpg"
                    style={{ display: "none" }}
                    ref={(el) => (inputRefs.current.passport_copy = el)}
                    onChange={(e) =>
                      handleFileChange("passport_copy", e.target.files[0])
                    }
                  />
                  {/* <label
                    htmlFor="file-passport_copy"
                    className="custom-upload-box"
                  >
                    {!form.files?.passport_copy ? (
                      <>
                        <span className="upload-placeholder">
                          {t("SupportedFormats")}: JPEG, PNG, PDF
                        </span>
                        <UploadIcon className="upload-svg-icon" />
                      </>
                    ) : (
                      <>
                        <span className="upload-filename">
                          {truncateFilename(
                            typeof form.files.passport_copy === 'string' 
                              ? form.files.passport_copy.split('/').pop() 
                              : form.files.passport_copy.name
                          )}
                        </span>
                        <span
                          className="upload-remove"
                          onClick={(e) => {
                            e.preventDefault();
                            handleFileRemove("passport_copy");
                          }}
                        >
                          ×
                        </span>
                      </>
                    )}
                  </label> */}

                  <label
                    htmlFor="file-passport_copy"
                    className="custom-upload-box"
                  >
                    {!form.files?.passport_copy ? (
                      <>
                        <span className="upload-placeholder">
                          {t("SupportedFormats")}: JPEG, PNG, PDF
                        </span>
                        <UploadIcon className="upload-svg-icon" />
                      </>
                    ) : (
                      <>
                        <span className="upload-filename">
                          {truncateFilename(
                            typeof form.files.passport_copy === "string"
                              ? form.files.passport_copy.split("/").pop()
                              : form.files.passport_copy.name
                          )}
                        </span>

                        <button
                          type="button"
                          className="file-action-btn view-file-btn"
                          onClick={(e) => {
                            e.preventDefault();
                            const file = form.files.passport_copy;
                            const isPdf =
                              (typeof file === "string" &&
                                file.toLowerCase().endsWith(".pdf")) ||
                              (file.name &&
                                file.name.toLowerCase().endsWith(".pdf"));
                            if (isPdf) {
                              window.open(
                                typeof file === "string"
                                  ? `${url}${file}`
                                  : URL.createObjectURL(file),
                                "_blank"
                              );
                            } else {
                              const previewUrl =
                                typeof file === "string"
                                  ? `${url}${file}`
                                  : URL.createObjectURL(file);
                              setPreviewImage(previewUrl);
                              setShowModal(true);
                            }
                          }}
                        >
                          {(() => {
                            const file = form.files.passport_copy;
                            const isPdf =
                              (typeof file === "string" &&
                                file.toLowerCase().endsWith(".pdf")) ||
                              (file.name &&
                                file.name.toLowerCase().endsWith(".pdf"));
                            return isPdf ? t("View") : t("Preview");
                          })()}
                        </button>

                        <button
                          type="button"
                          className="file-action-btn remove-file-btn"
                          onClick={(e) => {
                            e.preventDefault();
                            handleFileRemove("passport_copy");
                          }}
                        >
                          Remove
                        </button>
                      </>
                    )}
                  </label>

                  {err("file_passport_copy") && (
                    <div className="field-error">
                      {errors.file_passport_copy}
                    </div>
                  )}
                </div>
              </div>
            </Col>
          </Row>
        </Accordion.Body>
      </Accordion.Item>

      {/* 6. Declaration & Signature */}
      <Accordion.Item eventKey="5" className="hotel-form-accordion-item">
        <Accordion.Header className="hotel-form-accordion-header">
          6. {t("DeclarationAndSignature")}
        </Accordion.Header>
        <Accordion.Body className="hotel-form-accordion-body">
          <Row>
            <Col xl={12}>
              <div className="hotel-form-input-container" id="field-agreeTerms">
                <Form.Check
                  type="checkbox"
                  label={t("IAgreeToTheTermsAndConditions")}
                  checked={form.agreeTerms}
                  onChange={(e) =>
                    handleInputChange("agreeTerms", e.target.checked)
                  }
                  className="hotel-form-input-label"
                />
                {err("agreeTerms") && (
                  <div className="field-error">{errors.agreeTerms}</div>
                )}
              </div>
            </Col>

            <Col xl={6}>
              <div className="hotel-form-input-container" id="field-signature">
                <label className="hotel-form-input-label">
                  {t("Signature")} <span>*</span>
                </label>
                <div
                  className="signature-container"
                  style={{ position: "relative" }}
                >
                  <SignatureCanvas
                    ref={sigPadRef}
                    penColor="black"
                    canvasProps={{
                      width: 500,
                      height: 150,
                      className: "sigCanvas",
                    }}
                    onEnd={handleSignatureEnd}
                  />
                  <button
                    onClick={clearSignature}
                    title={t("Clear")}
                    style={{
                      position: "absolute",
                      top: 8,
                      right: 40,
                      background: "none",
                      border: "none",
                    }}
                  >
                    ⟳
                  </button>
                </div>
                {err("signature") && (
                  <div className="field-error">{errors.signature}</div>
                )}
              </div>
            </Col>
          </Row>
        </Accordion.Body>
      </Accordion.Item>
      {previewImage && (
        <div
          className={`modal fade ${
            showModal ? "show d-block" : ""
          } service-files-modal`}
          tabIndex="-1"
          role="dialog"
          style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
          onClick={() => setShowModal(false)}
        >
          <div className="modal-dialog modal-lg" role="document">
            <div className="modal-content">
              <button
                type="button"
                className="close"
                onClick={() => setShowModal(false)}
              ></button>
              <div className="service-image-file">
                <img
                  // src={initialData ? `${url}${previewImage}` : previewImage}
                  src={previewImage}
                  alt="preview"
                  style={{ maxWidth: "100%" }}
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </Accordion>
  );
});

export default ToursForm;